import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`/voucher/vouchers?${stringify(params)}`);
}
export async function create(params){
  return request('/voucher/vouchers', {
    method: 'POST',
    body: {
      ...params,
    },
  });
  //return request(`voucher/vouchers/create?${stringify(params)}`);
}

export async function get(id, params = {}){
  if (params) {
    return request(`/voucher/vouchers/${id}?${stringify(params)}`);
  }
  return request(`/voucher/vouchers/${id}`);
}

export async function update(params, id){
  return request(`/voucher/vouchers/${id}`, {
    method: 'POST',
    body: {
      ...params
    }
  });
}

export async function syncAll(params, id){
  return request(`/voucher/sync-vouchers/vouchers/${id}`, {
    method: 'POST',
    body: {
      ...params
    }
  });
}

export async function syncOne(params, id, partner_id){
  return request(`/voucher/sync-voucher/vouchers/${id}/partners/${partner_id}`, {
    method: 'POST',
    body: {
      ...params
    }
  });
}

export async function resetVoucherField(id, field){
  return request(`/voucher/vouchers/${id}/reset`, {
    method: 'POST',
    body: {
      reset_fields: field,
      id,
    }
  });
}